import { z } from 'zod';
import { CaseIdSchema, RelationIdSchema, SourceIdSchema } from './common.js';

/**
 * Typer relasjoner som kan eksistere mellom domeneobjekter.
 * Kobler f.eks. person → e-post, e-post → vedlegg, dokument → person.
 */
export const RelationTypeSchema = z.enum([
  'sent_email',
  'sent_message',
  'received_email',
  'has_attachment',
  'document_sent_in_email',
  'mentions_person',
  'belongs_to_thread',
  'belongs_to_conversation',
  'authored_document',
  'member_of_organization',
]);
export type RelationType = z.infer<typeof RelationTypeSchema>;

/** Gyldige node-typer i relasjonsgrafens kanter */
export const RelationNodeTypeSchema = z.enum([
  'case',
  'source',
  'source_item',
  'person',
  'organization',
  'document',
  'event',
]);
export type RelationNodeType = z.infer<typeof RelationNodeTypeSchema>;

export const RelationSchema = z.object({
  id: RelationIdSchema,
  caseId: CaseIdSchema,
  fromType: RelationNodeTypeSchema,
  fromId: z.string().min(1),
  toType: RelationNodeTypeSchema,
  toId: z.string().min(1),
  relationType: RelationTypeSchema,
  /** Konfidensscore mellom 0 og 1 – 1 = manuelt verifisert */
  confidence: z.number().min(0).max(1, 'Confidence må være mellom 0 og 1'),
  source: SourceIdSchema,
});

export type Relation = z.infer<typeof RelationSchema>;
